<template>
  <label :class="{
      'boxed': boxed,
      'customized-calendar': true,
      'has-placeholder': placeholder,
    }">
    <span v-if="placeholder"
          
          class="placeholder">
      {{ placeholder }}
    </span>
    <p-vue-calendar v-bind="$attrs" />
    <i-icon name="calendar" />
  </label>
</template>

<script>

export default {
  props: {
    boxed: Boolean,
    placeholder: String,
  }  
}

</script>

<style scoped>

  .customized-calendar {
    gap: 5px;
    display: grid;
    align-items: center;
    grid-template-columns: 1fr 27px;

    margin: 0;
    padding-bottom: 4px;

    border: 1px solid var(--color-border);
    border-width: 0 0 1px 0;
  }

  .customized-calendar.boxed {
    padding: 7.5px 10px;

    border-width: 1px 1px 1px 1px;
  }

  .customized-calendar.p-inputtext--alt {
    border-color: var(--color-border-alt);
  }

  .customized-calendar.has-placeholder {
    grid-template-columns: auto 1fr 27px;
  }

  .customized-calendar:deep(.p-calendar .p-inputtext) {
    padding: 0;

    border: none;
    border-radius: 0;
    background-color: transparent;
  }

  .customized-calendar:deep(.svg) {
    width: 27px;
    height: 23px;

    color: var(--color-success);
  }

</style>